import React from "react";
import { useFormatPrice } from "hooks";

// Configuration for table rows
const tableRowsConfig = (data, formatPrice) => [
  {
    label: `Subtotal (${data.totalItems} items)`,
    value: formatPrice(data.subtotal || 0),
    style: { borderBottom: "2px solid #ddd", marginBottom: "5px !important" },
  },
  {
    label: `Tax (${data.taxRate}%)`,
    value: formatPrice(data.taxAmt || 0),
  },
  {
    label: "Total Discount",
    value: `(-) ${formatPrice(data.totalDiscount || 0)}`,
    style: { borderBottom: "2px solid #ddd" },
  },
  {
    label: "Net Payable",
    value: `${formatPrice(data.netPayable || 0)}`,
    isBold: true,
  },
  ...(data.received > 0
    ? [
        {
          label: "Received",
          value: formatPrice(data.received || 0),
        },
        ...[
          ...data.payments.map((p) => ({
            label: p.payType ? `→  ${p.payType.name}` : "",
            value: formatPrice(p.amount),
          })),
        ],
        data.status === 1
          ? {
              label: "To Pay",
              value: formatPrice(data.netPayable - data.received),
              style: {
                borderTop: "2px solid #ddd",
              },
              isBold: true,
            }
          : {
              label: "Change",
              value: formatPrice(data.change || 0),
              style: {
                borderTop: "2px solid #ddd",
              },
              isBold: true,
            },
      ]
    : []),
];

const SummaryTable = ({ data }) => {
  const formatPrice = useFormatPrice();

  if (!data) return null;

  const rows = tableRowsConfig(data, formatPrice);

  return (
    <table
      style={{
        width: "100%",
        marginTop: "15px",
        borderCollapse: "collapse",
        textTransform: "uppercase",
      }}
    >
      <tbody>
        {rows.map((row, index) => (
          <tr key={index} style={{ ...row.style }}>
            <td
              style={{
                color: "#6f6f6f",
                fontSize: "14px",
                paddingBottom: "5px",
                paddingTop: "5px",
                fontWeight: row.isBold ? "bold" : "normal",
              }}
            >
              {row.label}
            </td>
            <td
              style={{
                textAlign: "right",
                color: "#6f6f6f",
                fontSize: row.isBold ? "18px" : "14px",
                fontWeight: row.isBold ? "bold" : "normal",
                paddingBottom: "5px",
                paddingTop: "5px",
              }}
            >
              {row.value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default React.memo(SummaryTable);
